// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3Xb1F","calendarButtons":"ClockData_calendarButtons__37pQy"};